import styled, {  createGlobalStyle } from 'styled-components'

// fonts
import UniNeueBookWoff from '../../fonts/subset-UniNeueBook.woff'
import UniNeueBookWoff2 from '../../fonts/subset-UniNeueBook.woff2'
import UniNeueHeavyWoff from '../../fonts/subset-UniNeueHeavy.woff'
import UniNeueHeavyWoff2 from '../../fonts/subset-UniNeueHeavy.woff2'
import UniNeueThinWoff from '../../fonts/subset-UniNeueThin.woff'
import UniNeueThinWoff2 from '../../fonts/subset-UniNeueThin.woff2'
import UniNeueBoldItalicWoff from '../../fonts/subset-UniNeueBold-Italic.woff'
import UniNeueBoldItalicWoff2 from '../../fonts/subset-UniNeueBold-Italic.woff2'
import UniNeueRegularItalicWoff from '../../fonts/subset-UniNeueRegular-Italic.woff'
import UniNeueRegularItalicWoff2 from '../../fonts/subset-UniNeueRegular-Italic.woff2'
import UniNeueBookItalicWoff from '../../fonts/subset-UniNeueBook-Italic.woff'
import UniNeueBookItalicWoff2 from '../../fonts/subset-UniNeueBook-Italic.woff2'
import UniNeueThinItalicWoff from '../../fonts/subset-UniNeueThin-Italic.woff'
import UniNeueThinItalicWoff2 from '../../fonts/subset-UniNeueThin-Italic.woff2'
import UniNeueLightWoff from '../../fonts/subset-UniNeueLight.woff'
import UniNeueLightWoff2 from '../../fonts/subset-UniNeueLight.woff2'
import UniNeueBoldWoff from '../../fonts/subset-UniNeueBold.woff'
import UniNeueBoldWoff2 from '../../fonts/subset-UniNeueBold.woff2'
import UniNeueHeavyItalicWoff from '../../fonts/subset-UniNeueHeavy-Italic.woff'
import UniNeueHeavyItalicWoff2 from '../../fonts/subset-UniNeueHeavy-Italic.woff2'
import UniNeueRegularWoff from '../../fonts/subset-UniNeueRegular.woff'
import UniNeueRegularWoff2 from '../../fonts/subset-UniNeueRegular.woff2'
import UniNeueLightItalicWoff from '../../fonts/subset-UniNeueLight-Italic.woff'
import UniNeueLightItalicWoff2 from '../../fonts/subset-UniNeueLight-Italic.woff2'
import UniNeueBlackWoff from '../../fonts/subset-UniNeueBlack.woff'
import UniNeueBlackWoff2 from '../../fonts/subset-UniNeueBlack.woff2'


export const GlobalWrapper = createGlobalStyle`
@font-face {
    font-family: 'Uni Neue Book';
    src: local('Uni Neue Book'), local('UniNeueBook'),
        url(${UniNeueBookWoff2}) format('woff2'),
        url(${UniNeueBookWoff}) format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Uni Neue';
    src: local('Uni Neue Heavy'), local('UniNeueHeavy'),
        url(${UniNeueHeavyWoff2}) format('woff2'),
        url(${UniNeueHeavyWoff}) format('woff');
    font-weight: 800;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Uni Neue';
    src: local('Uni Neue Thin'), local('UniNeueThin'),
        url(${UniNeueThinWoff2}) format('woff2'),
        url(${UniNeueThinWoff}) format('woff');
    font-weight: 100;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Uni Neue';
    src: local('Uni Neue Bold Italic'), local('UniNeueBold-Italic'),
        url(${UniNeueBoldItalicWoff2}) format('woff2'),
        url(${UniNeueBoldItalicWoff}) format('woff');
    font-weight: bold;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Uni Neue';
    src: local('Uni Neue Regular Italic'), local('UniNeueRegular-Italic'),
        url(${UniNeueRegularItalicWoff2}) format('woff2'),
        url(${UniNeueRegularItalicWoff}) format('woff');
    font-weight: 500;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Uni Neue Book';
    src: local('Uni Neue Book Italic'), local('UniNeueBook-Italic'),
        url(${UniNeueBookItalicWoff2}) format('woff2'),
        url(${UniNeueBookItalicWoff}) format('woff');
    font-weight: normal;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Uni Neue';
    src: local('Uni Neue Thin Italic'), local('UniNeueThin-Italic'),
        url(${UniNeueThinItalicWoff2}) format('woff2'),
        url(${UniNeueThinItalicWoff}) format('woff');
    font-weight: 100;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Uni Neue';
    src: local('Uni Neue Light'), local('UniNeueLight'),
        url(${UniNeueLightWoff2}) format('woff2'),
        url(${UniNeueLightWoff}) format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Uni Neue';
    src: local('Uni Neue Bold'), local('UniNeueBold'),
        url(${UniNeueBoldWoff2}) format('woff2'),
        url(${UniNeueBoldWoff}) format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Uni Neue';
    src: local('Uni Neue Heavy Italic'), local('UniNeueHeavy-Italic'),
        url(${UniNeueHeavyItalicWoff2}) format('woff2'),
        url(${UniNeueHeavyItalicWoff}) format('woff');
    font-weight: 800;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Uni Neue';
    src: local('Uni Neue Regular'), local('UniNeueRegular'),
        url(${UniNeueRegularWoff2}) format('woff2'),
        url(${UniNeueRegularWoff}) format('woff');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Uni Neue';
    src: local('Uni Neue Light Italic'), local('UniNeueLight-Italic'),
        url(${UniNeueLightItalicWoff2}) format('woff2'),
        url(${UniNeueLightItalicWoff}) format('woff');
    font-weight: 300;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Uni Neue';
    src: local('Uni Neue Black'), local('UniNeueBlack'),
        url(${UniNeueBlackWoff2}) format('woff2'),
        url(${UniNeueBlackWoff}) format('woff');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
}
`

export const LayoutWrapper = styled.div`
  display: block;
  overflow: hidden;
  padding-top: ${props => props.paddingTop ? '97px' : '0'};
  transition: padding .2s 0;
  min-height:100vh;
`

export const MainDiv = styled.main`
  min-height: 10vh;
`